import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';
import type { CreateNodepoolBody } from 'api/nodepools/types';

export const patchNodepoolsTE = <E = CF.API.ApiError>(
  { userId, computeClusterId, body }: { userId: string; computeClusterId: string; body: CreateNodepoolBody },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CreateNodepoolBody> =>
  fetchTE<CreateNodepoolBody, E>(
    {
      path: `/api/_api/v2/users/${userId}/compute_clusters/${computeClusterId}/nodepools`,
      method: 'PATCH',
      body,
    },
    onRejected,
  );
